<template>
  <v-select
    v-model="internalValue"
    outlined
    :items="permissions"
    :dense="dense"
    :label="label"
    @input="$emit('input', internalValue)" />
</template>

<script>
export default {
  name: 'PermissionSelect',
  props: {
    value: {
      type: Number,
      required: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    permissions: {
      type: Array,
      default: () => [
        { value: 0, text: '一般' },
        { value: 1, text: '協会審査員(ブロック)' },
        { value: 2, text: '協会審査員(全体)' },
      ],
    },
    label: {
      type: String,
      default: '権限',
    },
  },
  data: () => ({
    internalValue: 0,
  }),
  watch: {
    value(val) {
      this.internalValue = val
    },
  },
}
</script>

<style scoped>

</style>
